import { NgModule } from '@angular/core'
import { CourtSystemTimeZonePipe } from './court-system-timezone.pipe'

@NgModule({
  declarations: [CourtSystemTimeZonePipe],
  providers: [CourtSystemTimeZonePipe],
  exports: [CourtSystemTimeZonePipe],
})
export class CourtSystemTimezoneModule {}
